import React, { useEffect, useRef, useState } from "react";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import { scroll } from "../../../components/utils/utils";
import Loader from "../../../biblio/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import {
  toGetCompletedExternalPrograms,
  toGetExternalPrograms,
  toGetProgramsCategories,
} from "../../../apis/actions/programs.actions";
import SearchWithSelect from "../../../biblio/SearchWithSelect";
import ExternalProgramCards from "./ExternalProgramCards";

const ExternalPrograms = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    completedExternalPrograms,
    categories,
    statuscompletedExternalPrograms,
  } = useSelector((state: RootState) => state.programs);

  const { items: externalPrograms, loading } = useSelector(
    (state: RootState) => state?.programs?.externalPrograms
  );

  const [active, setActive] = useState<number>(1);
  const [searchState, setSearchState] = useState<any>({});
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isTablet, setIsTablet] = useState<boolean>(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const itemsPerPage = isMobile ? 4 : isTablet ? 4 : 3;
  const currentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= 1600);
      setIsTablet(window.innerWidth <= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getExternalPrograms();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const getExternalPrograms = async () => {
    await dispatch(toGetExternalPrograms());
    await dispatch(toGetProgramsCategories());
  };
  useEffect(() => {
    dispatch(
      toGetCompletedExternalPrograms({
        limit: itemsPerPage,
        page: active,
        category_id: selectedCategoryId ?? 1,
      })
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, selectedCategoryId]);
  useEffect(() => {
    handleToggle();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    externalPrograms,
    completedExternalPrograms,
    categories,
    statuscompletedExternalPrograms,
  ]);

  const handleToggle = (isCompleted: boolean = false) => {
    setSearchState({
      items: isCompleted ? completedExternalPrograms : externalPrograms,
      initialItems: isCompleted ? completedExternalPrograms : externalPrograms,

      options: [
        ...categories.map((option: any) => ({
          label: option.name,
          value: option.id,
        })),
      ],
      fieldsName: ["program_name", "details"],
      typeFieldName: "category_id",
      url: "",
      placeholderSelect: "اختر نوع البرنامج",
      toFilter: false,
      title: "",
      type: "البرامج",
      filteredProjects: externalPrograms,
      loading: statuscompletedExternalPrograms === "idle",
      titleBtnCompleted: isCompleted ? "البرامج المفتوحة" : "المكتملة",
      isCompleted: isCompleted,
      showIscompletedButton: true,
      types: categories,
    });
  };

  const updateActive = (nb: number) => {
    setActive(nb);
    scroll(currentRef);
  };

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  }
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="الرئيسية"
      subTitle="البرامج"
      urlImage={banner}
    >
      <section className="takaful--cases-section" style={{ marginTop: "2vh" }}>
        <div className="takaful--cases-header">
          <SearchWithSelect
            state={searchState}
            setFiltredList={(filtred, e) =>
              setSearchState({
                ...searchState,
                filteredProjects: filtred,
                toFilter: e,
              })
            }
            updateIsCompleted={() => handleToggle(!searchState.isCompleted)}
            onCategoryChange={(value) => setSelectedCategoryId(value)}
          />
        </div>
        <ExternalProgramCards
          state={searchState}
          startIndex={itemsPerPage * (active - 1)}
          endIndex={itemsPerPage * active}
          isMobile={isMobile}
          isTablet={isTablet}
        />
      </section>

      {searchState.filteredProjects &&
        searchState.filteredProjects.length > itemsPerPage && (
          <PaginationComponent
            active={active}
            scroll={() => scroll(currentRef)}
            total={searchState.filteredProjects.length}
            itemPerPage={itemsPerPage}
            setActive={(nb) => updateActive(nb)}
          />
        )}
    </MenuItemLayout>
  );
};

export default ExternalPrograms;
